import RepositoryService from 'src/services/repository'

const resource = 'rejectionCause'

export default {
  ...RepositoryService.utils.createCrudRepository(resource),
  getRejectionListForOperation: params => RepositoryService.crud.getList(`${resource}/available`, params),
}
